/**
 * API Configuration — Central endpoint URL resolver
 * In development (localhost), calls go to production server.
 * In production, uses relative paths.
 */

const isDev = window.location.hostname === 'localhost'
  || window.location.hostname === '127.0.0.1'
  || window.location.hostname === '[::1]';

const API_BASE = isDev
  ? 'https://quebecstore.ca'
  : '';  // relative in production

export const API = {
  subscribe:  `${API_BASE}/aica-mega-triggers/aica002-rsvp_more/r1-subscribe.php`,
  contact:    `${API_BASE}/aica-mega-triggers/aica002-rsvp_more/r2-contact.php`,
  soumission: `${API_BASE}/aica-mega-triggers/aica002-rsvp_more/r3-soumission.php`,
  unsubscribe:`${API_BASE}/aica-mega-triggers/aica002-rsvp_more/r5-unsubscribe.php`,
  abandon:    `${API_BASE}/aica-mega-triggers/aica002-rsvp_more/r9-abandon.php`,
};

export default API;
